'use strict';

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./cjs/react-is.production.min.js');
} else {
  module.exports = require('./cjs/react-is.development.js');
}



//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/react-is/index.js
// module id = 171
// module chunks = 2 3 4 5 6 8 9 10 11 13 15